import { render, staticRenderFns } from "./TbButton.vue?vue&type=template&id=12b71618&"
import script from "./TbButton.vue?vue&type=script&lang=ts&"
export * from "./TbButton.vue?vue&type=script&lang=ts&"
import style0 from "./TbButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports